import React from 'react';
import { Quote } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  author: string;
  age: number;
  location: string;
}
export function TestimonialCard({
  quote,
  author,
  age,
  location
}: TestimonialCardProps) {
  return <div className="bg-orange-50 p-6 rounded-lg shadow-sm border border-orange-100 relative" data-id="element-14">
      <Quote className="absolute top-4 left-4 w-8 h-8 text-orange-200 opacity-50" data-id="element-15" />
      <div className="relative z-10" data-id="element-16">
        <p className="text-gray-800 italic mb-4 text-lg leading-relaxed pt-4" data-id="element-17">
          "{quote}"
        </p>
        <div className="flex items-center mt-4 border-t border-orange-200 pt-4" data-id="element-18">
          <div className="w-10 h-10 bg-orange-200 rounded-full flex items-center justify-center text-orange-700 font-bold mr-3" data-id="element-19">
            {author.charAt(0)}
          </div>
          <div data-id="element-20">
            <p className="font-bold text-gray-900" data-id="element-21">
              {author}, {age}
            </p>
            <p className="text-sm text-gray-600" data-id="element-22">{location}</p>
          </div>
        </div>
      </div>
    </div>;
}